export default __webpack_public_path__ + "static/media/resin.f9ec8223.png";